module.exports = __webpack_public_path__ + "img/slot.9fa3fab7.webp";